

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const DOWNLOADKRAKPIQUESTIONSSAMPLEEXCELFILE= createAsyncThunk(
  "downloadKraKpiQuestionsSampleExcelFile/downloadKraKpiQuestionsSampleExcelFile",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const downloadKraKpiQuestionsSampleExcelFileSlice = createSlice({
  name: "downloadKraKpiQuestionsSampleExcelFileSlice",
  initialState: {
    downloadKraKpiQuestionsSampleExcelFile: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdownloadKraKpiQuestionsSampleExcelFile: (state) => {
        state.downloadKraKpiQuestionsSampleExcelFile.loading = false
        state.downloadKraKpiQuestionsSampleExcelFile.error = false
        state.downloadKraKpiQuestionsSampleExcelFile.data = []
        state.downloadKraKpiQuestionsSampleExcelFile.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DOWNLOADKRAKPIQUESTIONSSAMPLEEXCELFILE.fulfilled, (state, action) => {
      state.downloadKraKpiQuestionsSampleExcelFile = {
        ...state.downloadKraKpiQuestionsSampleExcelFile,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DOWNLOADKRAKPIQUESTIONSSAMPLEEXCELFILE.pending, (state, action) => {
      state.downloadKraKpiQuestionsSampleExcelFile = {
        ...state.downloadKraKpiQuestionsSampleExcelFile,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DOWNLOADKRAKPIQUESTIONSSAMPLEEXCELFILE.rejected, (state, action) => {
      state.downloadKraKpiQuestionsSampleExcelFile = {
        ...state.downloadKraKpiQuestionsSampleExcelFile,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const downloadKraKpiQuestionsSampleExcelFileAction = {
    DOWNLOADKRAKPIQUESTIONSSAMPLEEXCELFILE,
};

export { downloadKraKpiQuestionsSampleExcelFileAction };
export default downloadKraKpiQuestionsSampleExcelFileSlice.reducer;
export const {setInitialStateOfdownloadKraKpiQuestionsSampleExcelFile} = downloadKraKpiQuestionsSampleExcelFileSlice.actions
